import { Address } from "./Address";
import { Clothes } from "./Clothes";
import { GeneralStaff } from "./GeneralStaff";
import { Job } from "./Job";
import { PinGroup } from "./PinGroup";
import { Ribbon } from "./Ribbon";
import { User } from "./User";
import { Weapon } from "./Weapon";

export class Order {
    id: number;
    user: User;
    creationDate: Date;
    orderNumber: string;
    price: number;
    status: string;
    requestDate: Date;
    sigle: boolean;
    sigleDate: Date;    
    orderNumberBank: string;
    orderDetails: {
        id?: number;
        clothes: Clothes;
        size: string;
        amount: number;
        isChecked: boolean,
        ribbon: Ribbon,
        job: Job,
        generalStaff: GeneralStaff,
        weapon: Weapon,
        observation: string,
        height: string,
        thorax: string,
        waist:string, 
        pinGroup: PinGroup,
        pinObservation: String,
        [key:string]:any;
    }[];
    orderType: string;
    address: Address;
    confirmDate: Date;    
    preparation: boolean;
	preparationDate: Date;
	shipment: boolean;
	shipmentDate: Date;
	shipmentReference: string;
    storeTicketNumber: string;
}